import { memo, useMemo } from 'react'
import { Image, Table, Space, Popconfirm } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { Document } from 'types/documents'
import { modalTitle as formatModalTitle } from 'utils/modal-title'

type Props = {
    data: Document[]
    onEdit: (id: number) => void
    onDelete: (id: number) => void
    loading: boolean
}

export const DocumentsTable = memo((props: Props) => {
    const { data, onEdit, onDelete, loading } = props

    const columns: ColumnsType<Document> = useMemo(
        () => [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: '',
                key: 'image-preview',
                render: (_, record) =>
                    record.image ? <Image height={40} width={40} src={record.image} preview={false} /> : '—',
            },
            {
                title: 'Title',
                dataIndex: 'title',
                key: 'title',
            },
            {
                title: 'Link',
                dataIndex: 'link',
                key: 'link',
            },
            {
                title: 'Image',
                dataIndex: 'image',
                key: 'image',
                render: (value: string | undefined) => value ?? '—',
            },
            {
                title: 'Action',
                key: 'action',
                render: (_, record) => (
                    <Space size='middle'>
                        <a onClick={() => onEdit(record.id)}>Edit</a>
                        <Popconfirm
                            title={formatModalTitle('Delete document', record.title)}
                            description={'Are you sure to delete this document?'}
                            onConfirm={() => onDelete(record.id)}
                            okText={'Yes'}
                            cancelText={'No'}
                        >
                            <a href='#'>Delete</a>
                        </Popconfirm>
                    </Space>
                ),
            },
        ],
        [onDelete, onEdit]
    )

    return <Table loading={loading} columns={columns} dataSource={data} rowKey='id' pagination={false} />
})
